import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
/**
 * @description constructor
 * @params http
 */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
/**
 * @description Recuperar documentos
 * @params product
 * @params proveedor
 * @params portal
 * @params type
 */
  getAditinalDocument(product: number, proveedor: number, portal: number, type: number): Observable<ArrayBuffer> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = {
      id_Producto: product,
      id_Proveedor: proveedor,
      id_Portal: portal,
      id_Tipo_Documento: type
    };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.documentosadicionales.name,
      httpOpt
    );
  }
}
